import { createI18n } from 'vue-i18n'

const messages = {
  en: {
    filters: {
      title: 'Filters',
      types: 'Categories',
      reset: 'Reset',
      list: 'List',
      map: 'Map',
      all: 'All',
      fav: 'Fav',
      cancel: 'Cancel',
      apply: 'Apply',
    },
  },
  ro: {
    filters: {
      title: 'Filtre',
      types: 'Categorii',
      reset: 'Resetează',
      list: 'Listă',
      map: 'Hartă',
      all: 'Toate',
      fav: 'Fav',
      cancel: 'Anulează',
      apply: 'Aplică',
    },
  },
}

export default createI18n({
  locale: document.documentElement.lang,
  fallbackLocale: 'ro',
  legacy: false,
  messages,
})
